//이곳에서 임시 그 뭐냐 customColumnData Store 의 intergrated 를 만들어보자
import {ElectronApi} from "../util/electron/";
import * as MainSocket from "../components/main-socket/index.js";
import * as StatusSocket from "../components/user-status/index.js";

const {
    isSocketConnected,
    initDashboardSocket,
    receiveMainSocket,
    subscribeWidget,
    unsubscribeAllProject,
} = MainSocket
const setGlobal = (_window) => {
    _window.ElectronApi = ElectronApi
    _window.StatusSocket = StatusSocket
    _window.MainSocket = {
        isSocketConnected,
        initDashboardSocket,
        receiveMainSocket,
        subscribeWidget,
        unsubscribeAllProject,
    };
};

export default {
    setGlobal,
    ElectronApi
}
